import e from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const r = {
  display: "block"
}, x = ({ size: a = 16, useVw: t, useRem: i, color: n, withColor: c, removeClassName: l, disableSSR: m, style: o, ...p }) => {
  const v = o ? { ...r, ...o } : r;
  return /* @__PURE__ */ e.createElement(f, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-bibilicai", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (i ? "rem" : "px"), height: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (i ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: v, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: l ? "" : "32px-å¸å¸çè´¢"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: l ? "" : "normal",
        fill: c ? d(n, 0, "#262933") : "#262933",
        datafollowfill: c ? d(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M18.326 10.25a.84.84 0 1 0-1.58-.575l-.145.402-1.23-.447a1.228 1.228 0 0 0-1.574.734l-.664 1.825-.002-.001-1.239 3.403a1.228 1.228 0 0 0 .734 1.575l1.23.447-.147.402a.84.84 0 1 0 1.579.575l.146-.402.7.254a2.425 2.425 0 0 0 3.097-3.138 2.425 2.425 0 0 0-.351-4.397l-.7-.255.146-.402Zm-.533 3.635.012.004a.745.745 0 0 0 .5-1.403l-3.083-1.123-.51 1.4 3.08 1.122Zm-4.168 1.857.51-1.4 3.086 1.122.008.004a.745.745 0 0 1-.52 1.396l-3.084-1.123Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M25.975 13.973c0 5.509-4.466 9.975-9.975 9.975-5.509 0-9.975-4.466-9.975-9.975 0-5.51 4.466-9.975 9.975-9.975 5.51 0 9.975 4.466 9.975 9.975Zm-1.8 0a8.175 8.175 0 1 1-16.35 0 8.175 8.175 0 0 1 16.35 0Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M6.4 23.041a.9.9 0 1 0-1.8 0v.804a4.05 4.05 0 0 0 4.05 4.05h14.7a4.05 4.05 0 0 0 4.05-4.05v-.804a.9.9 0 1 0-1.8 0v.804a2.25 2.25 0 0 1-2.25 2.25H8.65a2.25 2.25 0 0 1-2.25-2.25v-.804Z"
        }
      )
    )
  )));
}, s = x;
export {
  s as default
};
